import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import { PricingSection } from '@/components/sections'

/**
 * Pricing Page Component
 * Displays pricing plans and options
 */
export const PricingPage = () => {
  return (
    <Box>
      <Seo
        title="Pricing"
        description="Simple, transparent pricing for plumbing company websites. Find the right plan to get a fast, modern website that generates leads and grows your business."
        path="/pricing"
      />
      <PricingSection />
    </Box>
  )
}
